/* eslint max-len: 0 */
export const messages = {
  header: {
    id: 'accountSettings.Page.Header',
    defaultMessage: 'Account Settings',
  },
  patientNotificationSettings: {
    title: {
      id: 'patientNotification.Settings.Title',
      defaultMessage: 'Notification Settings',
    },
    description: {
      id: 'patientNotification.Settings.Description',
      defaultMessage: 'Use these settings to choose which notifications the patient should receive and how they should be sent.',
    },
    emailLabel: {
      id: 'patientNotification.Settings.Label.Email',
      defaultMessage: 'Send emails to:',
    },
    notificationTypeTitle: {
      id: 'patientNotification.Settings.NotificationType.Title',
      defaultMessage: 'What notifications would you like to receive?',
    },
    submitButton: {
      id: 'patientNotification.Settings.Button.Submit',
      defaultMessage: 'Save Notification Settings',
    },
  },
  notificationTypeGrid: {
    followUpLabel: {
      id: 'notificationTypeGrid.Label.FollowUp',
      defaultMessage: 'Recommended Follow-ups:',
    },
    appointmentsLabel: {
      typeLabel: {
        id: 'notificationTypeGrid.Label.Appointments',
        defaultMessage: 'Scheduled Appointments:',
      },
      info: {
        id: 'notificationTypeGrid.Label.Appointments.Info',
        defaultMessage: 'Your facility is sending appointment notifications in digest format.  To receive the digest, you must enable email notifications.',
      },
    },
    secureMessageLabel: {
      id: 'notificationTypeGrid.Label.SecureMessage',
      defaultMessage: 'Messages:',
    },
    secureMessageOffset: {
      id: 'notificationTypeGrid.Offset.SecureMessage',
      defaultMessage: 'When a message arrives',
    },
    questionnairesLabel: {
      id: 'notificationTypeGrid.Label.Questionnaires',
      defaultMessage: 'Questionnaires:',
    },
    questionnairesOffset: {
      id: 'notificationTypeGrid.Offset.Questionnaires',
      defaultMessage: 'When questionnaire becomes available',
    },
  },
};
